import React, { ChangeEventHandler, KeyboardEvent, RefObject } from 'react';

interface IInputProps {
  id?: string;
  title?: string;
  placeholder?: string | undefined;
  value?: string | undefined;
  width?: string;
  onKeyDown?: () => void;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  defaultValue?: string;
  inputRef?: RefObject<HTMLInputElement>;
  inline?: boolean; // If true, title will be beside the input instead of on top
  maxCharacters?: number;
}

const SearchInput: React.FC<IInputProps> = ({
  id,
  title,
  placeholder,
  width,
  value,
  onKeyDown,
  disabled,
  inputRef,
  onChange,
  defaultValue,
  inline = false,
  maxCharacters,
}) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyDown?.();
    }
  };

  if (inline) {
    return (
      <div className="flex items-center gap-2">
        {title && (
          <label
            className="text-xs flex items-center whitespace-nowrap"
            htmlFor={id || 'search-input'}
          >
            {title}
          </label>
        )}
        <input
          id={id}
          ref={inputRef}
          className="border-solid border border-gray-600 rounded p-1 text-sm focus:outline-none"
          style={{ width }}
          type="text"
          disabled={disabled}
          maxLength={maxCharacters}
          name={id || 'search-input'}
          defaultValue={defaultValue}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={!disabled ? handleKeyDown : undefined}
          tabIndex={0}
        />
      </div>
    );
  }

  return (
    <div style={{ width }}>
      {title && (
        <label className="w-full font-bold text-sm" htmlFor={id || 'search-input'}>
          {title}
        </label>
      )}
      <input
        id={id}
        ref={inputRef}
        className="w-full border-solid border border-gray-600 rounded p-1 text-sm focus:outline-none"
        type="text"
        disabled={disabled}
        name={id || 'search-input'}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={!disabled ? handleKeyDown : undefined}
        tabIndex={0}
        maxLength={maxCharacters}
      />
    </div>
  );
};

export default SearchInput;
